import { isMorphdomHeld } from "web-ui/morphdom/hold"

export function isMorphdomIgnored(element) {
  return "turboMorphIgnore" in element.dataset || isMorphdomHeld(element)
}
